/** Authoring helpers for variable links in Google Docs templates.
 *
 * Google Docs refuses `{{ profile_url }}` as a link target — it demands a
 * resolvable URL. So authors link to `https://<variable_name>` instead and zip
 * ingestion rewrites it to Jinja. Docs accepts the bare underscored host and
 * round-trips it verbatim (verified against a real export, 2026-07-24).
 */

/** Whether this variable holds a URL, and so can be used as a link target. */
export function isLinkVariable(name: string): boolean {
  return name.endsWith("_url");
}

/** What the author pastes into the Docs link dialog for `name`. */
export function linkSentinel(name: string): string {
  return `https://${name}`;
}
